[
 {
  "id": "row",
  "x": 80,
  "y": 621,
  "w": 780,
  "h": 169
 },
 {
  "id": "tag",
  "x": 236,
  "y": 974,
  "w": 236,
  "h": 60
 },
 {
  "id": "balance",
  "x": 196,
  "y": 440,
  "w": 522,
  "h": 146
 }
]